import React, { useEffect, useRef } from "react";
import {
  SelectionCell,
  SelectionItemRemove,
  ProductImagePlaceholder,
} from "../styles";
import { MobileSelectionItemRemove } from "../styles/MobileStyles";
import PersonalisationInput from "./PersonalisationInput";

import Misc from "./common/Misc.svg";

const SelectionItem = ({
  currentIndex,
  selectionItem,
  focusedProduct,
  singleMessage,
  editable,
  personalisationSelected,
  handleAddMessage,
  firstMsg,
  setFirstMsg,
  handleSingleMessage,
  setSingleMessage,
  presetMsg,
  setPresetMsg,
  isMobile,
  selection,
  setFocusedProduct,
  getCharacterCount,
  updateItemRemove,
}) => {


  const randomTiming = () => {
    return (Math.random() * (0.6 - 0.35) + 0.35).toFixed(2);
  };

  const randomDelay = () => {
    return (Math.random() - 0.75).toFixed(2);
  };

  const handleItemRemove = (index, item) => {
    item.bId === focusedProduct ? setFocusedProduct(null) : null;
    updateItemRemove(index);
  };

  const ProductImg = useRef(null);

  useEffect(() => {
    if (selectionItem) {
      setTimeout(() => {
        ProductImg.current.classList.add("fadeIn");
      }, 100 );
    }
  }, [selectionItem]);

  return (
    <SelectionCell
      id={currentIndex}
      className={`      
    ${selectionItem ? "product" : ""} ${
        focusedProduct &&
        selectionItem &&
        focusedProduct.bId === selectionItem.bId &&
        singleMessage
          ? "focus"
          : ""
      }`}
      key={currentIndex + 6}
    >
      <ProductImagePlaceholder
        className={`product-img-placeholder ${editable ? "editing" : ""} ${
          personalisationSelected &&
          !isMobile &&
          selectionItem?.personalisation_available === "N"
            ? " fade"
            : ""
        }
      `}
        onClick={
          selectionItem && isMobile && editable
            ? () => updateItemRemove(currentIndex)
            : selectionItem && !isMobile
            ? () => handleItemRemove(currentIndex, selectionItem)
            : null
        }
      >
        {selectionItem ? (
          <>
            {editable && (
              <MobileSelectionItemRemove>
                {Misc.MobileSelectionRemove}
              </MobileSelectionItemRemove>
            )}
            <img
              ref={ProductImg}
              style={{
                animationDelay: editable ? `${randomDelay()}s` : "",
                animationDuration: editable ? `${randomTiming()}s` : "",
              }}
              src={selectionItem.img}
              alt={`${selectionItem.frontend_title} in selection`}
            />
          </>
        ) : (
          <img
            className="empty-slot-img"
            src="https://cdn.shopify.com/s/files/1/0503/8954/9250/files/cupcake-illustration.svg?v=1716886938"
          ></img>
        )}
      </ProductImagePlaceholder>
      {!isMobile && selectionItem && (
        <SelectionItemRemove
          onClick={() => handleItemRemove(currentIndex, selectionItem)}
        >
          {Misc.MobileSelectionRemove}
        </SelectionItemRemove>
      )}

      {selectionItem &&
      selectionItem.personalisation_available === "Y" &&
      personalisationSelected &&
      !isMobile ? (
        <PersonalisationInput
          key={currentIndex + 7}
          item={selectionItem}
          handleAddMessage={handleAddMessage}
          firstMsg={firstMsg}
          setFirstMsg={setFirstMsg}
          singleMessage={singleMessage}
          handleSingleMessage={handleSingleMessage}
          setSingleMessage={setSingleMessage}
          presetMsg={presetMsg}
          setPresetMsg={setPresetMsg}
          isMobile={isMobile}
          selection={selection}
          focusedProduct={focusedProduct}
          setFocusedProduct={setFocusedProduct}
          getCharacterCount={getCharacterCount}
        />
      ) : (
        <span
          className={`text-capitalize mt-1  ${isMobile ? "text-center" : ""} ${
            selectionItem?.personalisation_available === "N" &&
            personalisationSelected &&
            !isMobile
              ? "fade"
              : ""
          }`}
        >
          {((!personalisationSelected ||
            (personalisationSelected &&
              selectionItem?.personalisation_available === "N")) &&
            !isMobile &&
            selectionItem) ||
          isMobile
            ? selectionItem
              ? selectionItem.frontend_title
              : "empty"
            : null}
        </span>
      )}
    </SelectionCell>
  );
};

export default SelectionItem;
